import axiosInstance from '../../../config/axiosInstance';
import { UpdatePartBOMValidation } from "../View/Validation/UpdatePartBOM";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors, redirectCallback, redirectUserList) => {
  debugger;
  event.preventDefault();
  const formErrors = UpdatePartBOMValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID=localStorage.getItem("CompanyID");
      formData.ClientID=CompanyID;
      const UserID=localStorage.getItem("UserID");
      formData.UserID=UserID;
      const response = await axiosInstance.post(`/Part/UpdateStockLocationBOM`, formData);
      redirectUserList();
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };